import { axiosInstance } from "@follosoft/react-components";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useDeleteContractAlertTarget() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number | string) => {
      return axiosInstance().delete(
        `/folloportal/contract-alert-targets/${id}`
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["contract-alert-targets"],
      });
    },
  });
}
